import { StockReceiptForm } from "../components/stockReceipt/StockReceiptForm";

export const StockReceiptPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Stock Receipt</h1>
        <p className="text-gray-500 mt-1">
          Record incoming stock from suppliers
        </p>
      </div>

      <StockReceiptForm />
    </div>
  );
};